/**
 * @module enum
 */
export enum GroupMemberRoleTypeEnum {
    /**
     * 群成员
     */
    V2TIM_GROUP_MEMBER_ROLE_MEMBER = 200,
    /**
     * 群管理员
     */
    V2TIM_GROUP_MEMBER_ROLE_ADMIN = 300,
    /**
     * 群主
     */
    V2TIM_GROUP_MEMBER_ROLE_OWNER = 400,
    V2TIM_GROUP_MEMBER_UNDEFINED = 0
}
